import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { marshalltownConfig } from "./data";

export default function MarshalltownPage() {
  return <CityPageTemplate config={marshalltownConfig} />;
}